import { render } from "./ViewGeneral.vue?vue&type=template&id=3a849bf9"
import script from "./ViewGeneral.vue?vue&type=script&lang=js"
export * from "./ViewGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__